var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassMenu",
    {
      ref: "contextmenu-" + _vm.id,
      attrs: {
        trigger: "click",
        "custom-class": "listing-context-menu",
        placement: "left-start"
      },
      on: { open: _vm.handleOpenMenu, close: _vm.handleCloseMenu },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function() {
            return [
              _vm._l(_vm.items, function(item, index) {
                return [
                  item.subitems
                    ? _c("CompassMenuGroup", {
                        key: "contextmenu-subitem-" + _vm.id + "-" + index,
                        attrs: {
                          placement: "left-start",
                          label: item.label,
                          disabled: item.disabled
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "dropdown",
                              fn: function() {
                                return _vm._l(item.subitems, function(
                                  subitem,
                                  subindex
                                ) {
                                  return _c("CompassMenuItem", {
                                    key:
                                      "contextmenu-item-" +
                                      _vm.id +
                                      "-" +
                                      index +
                                      "-" +
                                      subindex,
                                    attrs: {
                                      label: subitem.label,
                                      disabled: subitem.disabled
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.goto(
                                          subitem.action,
                                          subitem.target,
                                          subitem.type,
                                          _vm.id
                                        )
                                      }
                                    }
                                  })
                                })
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    : _c("CompassMenuItem", {
                        key: "contextmenu-item-" + _vm.id + "-" + index,
                        attrs: { disabled: item.disabled, label: item.label },
                        on: {
                          click: function($event) {
                            return _vm.goto(
                              item.action,
                              item.target,
                              item.type,
                              _vm.id
                            )
                          }
                        }
                      })
                ]
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [_c("CompassIconButton", { attrs: { size: "medium", icon: "action" } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }